


















import { Component, Prop } from 'vue-property-decorator'
import Vue from 'vue'

export const HADES_BTN_SIZE = {
  XSMALL: 'xs',
  SMALL: 'sm',
  BASE: 'base',
  LARGE: 'lg',
  XLARGE: 'xl',
}

/**
 * 버튼 컴포넌트 입니다. 슬롯으로 사용합니다.
 */
@Component
export default class HdsBtn extends Vue {
  name = 'HdsBtn'

  /**
   * 비활성화 여부입니다.
   */
  @Prop({
    type: Boolean,
    default: false,
  })
  disabled!: boolean

  /**
   * Primary 컬러셋을 사용합니다.
   */
  @Prop({
    type: Boolean,
    default: false,
  })
  primary!: boolean

  /**
   * Secondary 컬러셋을 사용합니다.
   */
  @Prop({
    type: Boolean,
    default: false,
  })
  secondary!: boolean

  /**
   * 외곽선 스타일을 사용합니다.
   */
  @Prop({
    type: Boolean,
    default: false,
  })
  outlined!: boolean

  /**
   * 텍스트 스타일을 사용합니다.
   */
  @Prop({
    type: Boolean,
    default: false,
  })
  text!: boolean

  /**
   *  아이콘 스타일을 사용합니다.
   */
  @Prop({
    type: Boolean,
    default: false,
  })
  icon!: boolean

  /**
   *  Fab 스타일을 사용합니다.
   */
  @Prop({
    type: Boolean,
    default: false,
  })
  fab!: boolean

  /**
   *  Tile 스타일을 사용합니다.
   */
  @Prop({
    type: Boolean,
    default: false,
  })
  tile!: boolean

  /**
   *  더 둥근 스타일을 사용합니다.
   */
  @Prop({
    type: Boolean,
    default: false,
  })
  rounded!: boolean

  /**
   *  블록 스타일을 사용합니다.
   */
  @Prop({
    type: Boolean,
    default: false,
  })
  block!: boolean

  /**
   *  텍스트를 대문자로 변환하지 않습니다.
   */
  @Prop({
    type: Boolean,
    default: false,
  })
  noUpperCase!: boolean

  /**
   * 버튼의 크기를 선택합니다.
   */
  @Prop({
    type: String,
    default: HADES_BTN_SIZE.BASE,
    validator: function (value) {
      return Object.values(HADES_BTN_SIZE).indexOf(value) !== -1
    },
  })
  size!: string

  /**
   * 색을 지정합니다.
   */
  @Prop({
    type: String,
  })
  color?: string

  /**
   * 테두리 색을 지정합니다.
   */
  @Prop({
    type: String,
  })
  boxShadowColor?: string

  /**
   * 배경색을 지정합니다.
   */
  @Prop({
    type: String,
  })
  backgroundColor?: string

  /**
   * Dense
   */
  @Prop({
    type: Boolean,
    default: false,
  })
  dense!: boolean

  /**
   * Ripple
   */
  @Prop({
    type: Boolean,
    default: true,
  })
  ripple!: boolean

  get classes() {
    return {
      'hds-button': true,
      'hds-disabled': this.disabled,
      'hds-button--primary': this.primary,
      'hds-button--secondary': this.secondary,
      'hds-button--outlined': this.outlined,
      'hds-button--text': this.text,
      'hds-button--icon': this.icon,
      'hds-button--fab': this.fab,
      'hds-button--tile': this.tile,
      'hds-button--rounded': this.rounded,
      'hds-button--block': this.block,
      'hds-button--no-upper-case': this.noUpperCase,
      [`hds-button--${this.size}`]: true,
      'hds-button--dense': this.dense,
      'cursor-default': !this.ripple,
    }
  }

  get styles() {
    return {
      color: this.color,
      backgroundColor: this.backgroundColor,
      boxShadow: `0px 0px 0px 1px ${this.boxShadowColor}`,
    }
  }

  onMousedown(evt: Event) {
    this.$emit('mousedown', evt)
  }

  onMouseup(evt: Event) {
    this.$emit('mouseup', evt)
  }

  onClick(evt: Event) {
    this.$emit('click', evt)
  }
}
